import { css } from 'styled-components';
export const base = () => css(["padding:0.4rem;box-shadow:0 2px 1rem 0 rgba(0,0,0,0.3);line-height:0;display:inline-block;"]);
//# sourceMappingURL=FramedImage.style.js.map